import AdminPushHttpService from 'dataStore/service/adminPush.service'

/**
 * Синхронизирует preferred-фильтр пиццерии для всех push-подписок админа.
 * @param preferredPizzeriaId — null = все в scope
 */
export const syncAdminPushPreference = async (
  preferredPizzeriaId: number | null
): Promise<void> => {
  if (typeof Notification === 'undefined' || Notification.permission !== 'granted') {
    return
  }
  try {
    await AdminPushHttpService.patchPreference(preferredPizzeriaId)
  } catch (error) {
    console.error('Ошибка синхронизации push-фильтра:', error)
  }
}
